import { Attributes, ModelBase, NeoModel, Rules } from "@singularsystems/neo-core";

@NeoModel
export default class CorporateActionEventLookup extends ModelBase {
    public corporateActionEventID: number = 0;

    public isCompleted: boolean = false;
}